import { render } from "./AppointmentDataForm.vue?vue&type=template&id=52740316&scoped=true&ts=true"
import script from "./AppointmentDataForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentDataForm.vue?vue&type=script&lang=ts"

import "./AppointmentDataForm.vue?vue&type=style&index=0&id=52740316&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52740316"]])

export default __exports__